/**
 * 创建人：王靖
 * 时间：2019-3-29
 * 描述：tip:成功 信息 警告 错误
 * 更新记录: 
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'sw-tip',
  templateUrl: './sw-tip.component.html',
  styleUrls: ['./sw-tip.component.css']
})
export class SwTipComponent {
  @Input() message: string; //显示数据
  @Input() type: string; //显示类型  s i w e 

  constructor() { }
}
